export const RECENTLY_VIEWED_PRODUCTS_LOCAL_STORAGE_KEY =
  'RECENTLY_VIEWED_PRODUCTS';

export const MAX_PRODUCT_CARDS = 6;

export const MAX_STORED_RECENTLY_VIEWED = 100;
